// components/settings/BasicInfo.jsx
import { useState } from "react";
import { toast } from "react-toastify";
import { httpRequest } from "../../utils/httpRequest";
import { useTranslation } from "react-i18next"; // ← اضافه شده

const BasicInfo = ({ user }) => {
  const { t } = useTranslation(); // ← اضافه شده
  const [name, setName] = useState(user.name || "");
  const [birthdate, setBirthdate] = useState(user.birthdate || "");

  const handleSave = async () => {
    const token = JSON.parse(localStorage.getItem("user"))?.token;
    try {
      await httpRequest(
        "POST",
        "/user/complete-info",
        { userId: user._id, name, birthdate },
        { "x-access-token": token }
      );
      toast.success(t('basic_info.toast_success'));
    } catch {
      toast.error(t('basic_info.toast_error'));
    }
  };

  return (
    <section className="bg-white rounded-xl shadow p-4 space-y-4">
      <h2 className="text-lg font-semibold text-gray-800">{t('basic_info.title')}</h2>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm mb-1 text-gray-600">{t('basic_info.name_label')}</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400"
          />
        </div>
        <div>
          <label className="block text-sm mb-1 text-gray-600">{t('basic_info.birthdate_label')}</label>
          <input
            type="text"
            value={birthdate}
            onChange={(e) => setBirthdate(e.target.value)}
            className="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400"
          />
        </div>
      </div>
      <button
        onClick={handleSave}
        className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 text-sm"
      >
        {t('basic_info.save_button')}
      </button>
    </section>
  );
};

export default BasicInfo;